/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { APP_BOOTSTRAP_LISTENER, ComponentRef, inject, NgModule, PLATFORM_ID, TransferState } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserModule, provideClientHydration, REMOVE_STYLES_ON_COMPONENT_DESTROY } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpInterceptorProviders } from 'src/app/shared/interceptors/http-interceptor';
import { translateBrowserLoaderFactory } from 'src/app/shared/loader/translate-browser.loader.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN, NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { environment } from 'src/environments/environment';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { isPlatformBrowser } from '@angular/common';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './material/material.module';
import { GoogleAnalyticService } from './core/services/analytics.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { PreloadAllModules, RouterModule } from '@angular/router';

// export function playerFactory() {
//     const platformId = inject(PLATFORM_ID);
//     if (isPlatformBrowser(platformId)) {
//         // dynamic import only on browser
//         return import('lottie-web').then((module) => module.default);
//     }
//     return null as any; // no player on server
// }

export function playerFactory() {
   const platformId = inject(PLATFORM_ID);
    if (isPlatformBrowser(platformId)) {
        // dynamic import only on browser
         return import('lottie-web').then((module) => module.default);
    }
    return null as any; // no player on server
}

@NgModule({
    declarations: [
        AppComponent,
        SignUpComponent,
    ],
    imports: [
        AppRoutingModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: translateBrowserLoaderFactory,
                deps: [HttpClient, TransferState],
            },
        }),
        BrowserAnimationsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        FormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MaterialModule,
        NgxGoogleAnalyticsModule,
        DigitOnlyModule,
    ],
    providers: [
        httpInterceptorProviders,
        provideClientHydration(),
        provideHttpClient(withFetch()),
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN,
            useValue: {
                trackingCode: environment.gaMid,
                initCommands: [{ command: 'config', values: [{ send_page_view: false, client_storage: 'none', anonymize_ip: true }] },
            { command: 'config', values: [environment.adsId, { send_page_view: false }] }],
                nonce: 'FBCc7XlLkS0UPwyoTGzYag==',
            },
        },
        {
            provide: APP_BOOTSTRAP_LISTENER,
            multi: true,
            useFactory: (analyticsService: GoogleAnalyticService) => (component: ComponentRef<unknown>) => {
                analyticsService.initializeGoogleAnalytics(component);
            },
            deps: [GoogleAnalyticService],
        },
        provideLottieOptions({ player: playerFactory }),
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
